import { PageType } from "shared/lib/page-type";

import type { AppBarVariant } from "scmp-app/components/app-bar/types";
import type { ArticleRenderType } from "scmp-app/components/article/article-render/types";

export const pathname = "/article";

export const page = {
  route(
    query: QueryParameters<{
      appBarVariant?: AppBarVariant;
      commentID?: string;
      entityId: string;
      entityUuid: string;
      renderType?: ArticleRenderType;
      share?: string;
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Article },
    };
  },
};
